import {query} from '@di-nxt/query';
import {getDateString} from '../../../utils';
import {DailyWorkload, ScheduleDataModel} from '../types';

/**
 * Returns the total capacity and assigned hours for a day with
 * the data for the current view model
 * @param date
 * @param viewmodel
 */
export const getDailyWorkload = (
  date: Date | string,
  viewmodel: ScheduleDataModel,
): DailyWorkload => {
  const isoDate = getDateString(date);
  const shiftsWithTasksOnDate = query(viewmodel.shiftsWithTasks).where(
    st => st.shift.distrDate === isoDate,
  );
  const unassignedTasksOnDate = query(viewmodel.unassignedTasks).where(
    ut => ut.distrDate === isoDate,
  );

  return {
    totalCapacityHours:
      shiftsWithTasksOnDate.sum(st => st.shift.durationMinutes) / 60,
    totalAssignedTaskHours: shiftsWithTasksOnDate.sum(st => st.totalTasksHours),
    totalUnassignedTaskHours:
      unassignedTasksOnDate.sum('durationMinutesEstimated') / 60,
  };
};
